import type { KanbanEvento } from '@pieltec/contracts';

export function interpretarEvento(texto: string): KanbanEvento | null {
  try {
    const obj: unknown = JSON.parse(texto);
    if (typeof obj === 'object' && obj !== null && typeof (obj as Record<string, unknown>).tipo === 'string') {
      return obj as KanbanEvento;
    }
    return null;
  } catch {
    return null;
  }
}

export const ATRASO_RECONEXAO_INICIAL_MS = 2000;
export const ATRASO_RECONEXAO_MAX_MS = 60_000;
/** Falhas seguidas antes de sondar o endpoint para distinguir 401/403 de queda de rede. */
export const FALHAS_ANTES_DA_SONDAGEM = 2;

/** Backoff exponencial da reconexão: 2 s, 4 s, 8 s ... teto de 60 s (WR-WEB-12). */
export function atrasoReconexaoMs(falhasConsecutivas: number): number {
  const falhas = Math.max(1, Math.floor(falhasConsecutivas));
  return Math.min(ATRASO_RECONEXAO_INICIAL_MS * 2 ** Math.min(falhas - 1, 16), ATRASO_RECONEXAO_MAX_MS);
}

export type ResultadoSondagemSse = 'nao_autorizado' | 'disponivel' | 'indisponivel';

/** Status da sondagem do stream: 401/403 é definitivo (não adianta reconectar em loop). */
export function classificarSondagemSse(status: number): ResultadoSondagemSse {
  if (status === 401 || status === 403) return 'nao_autorizado';
  if (status >= 200 && status < 300) return 'disponivel';
  return 'indisponivel';
}

export function criarDebounce<TArgs extends readonly unknown[]>(fn: (...args: TArgs) => void, ms: number): (...args: TArgs) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  return (...args: TArgs) => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn(...args);
    }, ms);
  };
}
